import { useMutation } from '@tanstack/react-query';
import { request } from '../axios';
import type { IPersonListItem } from '../generated/person-controller/person-controller';

export interface PersonMatchCheckPayload {
  firstName: string;
  lastName: string;
  birthDate: string;
}

export type PersonMatchCheckResponse = IPersonListItem[];

export function checkPersonMatch(payload: PersonMatchCheckPayload) {
  return request<PersonMatchCheckResponse>({
    url: '/api/persons/match-check',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: payload,
  });
}

export function useCheckPersonMatchMutation() {
  return useMutation({
    mutationFn: checkPersonMatch,
  });
}
